__turbopack_context__.v({
  "aspect-ratio-content": "flat-header-module-scss-module__Glvhuq__aspect-ratio-content",
  "header": "flat-header-module-scss-module__Glvhuq__header",
  "scrolled": "flat-header-module-scss-module__Glvhuq__scrolled",
  "week-name": "flat-header-module-scss-module__Glvhuq__week-name",
  "week-names-container-mobile": "flat-header-module-scss-module__Glvhuq__week-names-container-mobile",
  "week-names-container-mobile__default": "flat-header-module-scss-module__Glvhuq__week-names-container-mobile__default",
});
